import * as React from 'react';
import styles from './index.less';
import { Dropdown, DropdownProps } from 'antd';

interface FDropdownProps extends DropdownProps {

}

function FDropdown({ ...props }: FDropdownProps) {
  return (<Dropdown
    overlayClassName={styles.overlayClassName}
    {...props}
  />);
}

export default FDropdown;
